import {excess} from '@fl/cmsch-fe-library';
import * as t from 'io-ts';

const requiredPart = excess(t.partial({
    approvedFrom: t.string,
    approvedTo: t.string,
    farmIds: t.string,
    roleIds: t.string,
    breederId: t.string,
}));

export const ValidateBreederErrorsSchema = t.interface({binding: requiredPart});
